import React from 'react'
import { COMMON } from 'utils/intl/common.js'
import { useGlobalState } from 'utils/hooks/globalStateProvider'
import { STATUS_SUCCESS } from 'utils/constants.js'

export function ShareLinkedin(props) {
  const { children, url, className = '' } = props
  return (
    <a
      className={className}
      href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  )
}

export function ShareTwitter(props) {
  const { children, url, className = '' } = props
  return (
    <a
      className={className}
      href={`https://twitter.com/intent/tweet?url=${url}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  )
}

export function ShareReddit(props) {
  const { children, url, className = '' } = props
  return (
    <a className={className} href={`http://www.reddit.com/submit?url=${url}`} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  )
}

export function ShareHackernews(props) {
  const { children, url, className = '' } = props
  return (
    <a
      className={className}
      href={`https://news.ycombinator.com/submitlink?u=${url}&t=${url
        .split('/')
        [url.split('/').length - 1].replaceAll('-', ' ')}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  )
}

export function ShareCopyLink(props) {
  const [, dispatch] = useGlobalState()
  const { children, url, className = '' } = props

  const copyToClipboard = (url) => {
    const inputc = document.body.appendChild(document.createElement('input'))
    inputc.style.position = 'fixed'
    inputc.style.bottom = 0
    inputc.style.left = 0
    inputc.value = url
    inputc.focus()
    inputc.select()
    document.execCommand('copy')
    inputc.parentNode.removeChild(inputc)

    dispatch({
      message: {
        isOpen: true,
        text: COMMON.COPIED_CLIPBOARD,
        status: STATUS_SUCCESS,
      },
    })
  }

  return (
    <span
      className={className}
      role="button"
      tabIndex="0"
      onClick={() => copyToClipboard(url)}
      onKeyDown={() => copyToClipboard(url)}
    >
      {children}
    </span>
  )
}
